"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 52 31"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    id: "a",
    x1: "37.778%",
    x2: "61.249%",
    y1: "12.322%",
    y2: "113.353%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#87C54D"
  }), react_1.default.createElement("stop", {
    offset: "13.98%",
    stopColor: "#7FC34D"
  }), react_1.default.createElement("stop", {
    offset: "34.69%",
    stopColor: "#68BD4F"
  }), react_1.default.createElement("stop", {
    offset: "59.46%",
    stopColor: "#34B451"
  }), react_1.default.createElement("stop", {
    offset: "72.75%",
    stopColor: "#00AF53"
  })), react_1.default.createElement("linearGradient", {
    id: "b",
    x1: "39.471%",
    x2: "57.444%",
    y1: "28.866%",
    y2: "78.749%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FDC110"
  }), react_1.default.createElement("stop", {
    offset: "13.52%",
    stopColor: "#FCBB13"
  }), react_1.default.createElement("stop", {
    offset: "33.56%",
    stopColor: "#F8AC1A"
  }), react_1.default.createElement("stop", {
    offset: "57.64%",
    stopColor: "#F3941F"
  }), react_1.default.createElement("stop", {
    offset: "84.64%",
    stopColor: "#EC7423"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#E95D24"
  }))), react_1.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, react_1.default.createElement("g", null, react_1.default.createElement("ellipse", {
    cx: "26.044",
    cy: "16.627",
    fill: "#A6CAE4",
    rx: "25.89",
    ry: "14.286"
  }), react_1.default.createElement("path", {
    fill: "#D3EAF1",
    d: "M51.934 14.286c0 1.496-.419 2.927-1.19 4.292-3.283 5.788-13.11 9.994-24.7 9.994-11.502 0-21.263-4.14-24.634-9.885C.595 17.299.154 15.825.154 14.286c0-1.279.309-2.536.882-3.707C4.01 4.487 14.08 0 26.044 0 38.097 0 48.232 4.552 51.12 10.71c.528 1.148.815 2.34.815 3.576z"
  }), react_1.default.createElement("path", {
    fill: "#A6CAE4",
    d: "M41.82 14.286c0 .39-.044.78-.154 1.17-1.035 4.25-7.624 7.545-15.622 7.545S11.436 19.727 10.4 15.457c-.11-.39-.154-.78-.154-1.171 0-4.813 7.073-8.715 15.776-8.715 8.747 0 15.798 3.902 15.798 8.715z"
  }), react_1.default.createElement("path", {
    fill: "#D3EAF1",
    d: "M40.41 15.457c-.947 3.923-7.007 6.937-14.366 6.937-7.36 0-13.419-3.014-14.366-6.937.947-3.902 7.029-6.916 14.366-6.916 7.36-.021 13.419 3.014 14.366 6.916z"
  })), react_1.default.createElement("path", {
    fill: "url(#a)",
    d: "M20.337 2.948s4.892-5.072 8.726-1.734c0 0 2.996 2.623-2.005 3.924 0 0-5.289-2.081-6.83-1.128-1.521.954.11-1.062.11-1.062z",
    transform: "translate(16.085 3.902)"
  }), react_1.default.createElement("path", {
    fill: "url(#b)",
    d: "M20.403 3.317S16.878-.477 7.976 6.785c0 0-7.117 5.81-7.888 8.455 0 0 7.47-.78 11.215-2.558 0 0 12.956-5.355 9.1-9.365z",
    transform: "translate(16.085 3.902)"
  }), react_1.default.createElement("path", {
    fill: "#F68B1F",
    d: "M23.995 11.164s1.807.672 2.424 2.125l-2.424-2.125z"
  }), react_1.default.createElement("path", {
    fill: "#D37819",
    d: "M28.027 12.682s1.63.975 1.763 1.842c.154.868-1.763-1.842-1.763-1.842z"
  }), react_1.default.createElement("path", {
    fill: "#F68B1F",
    d: "M21.042 13.744s2.226.672 2.975 2.125l-2.975-2.125z"
  }), react_1.default.createElement("path", {
    fill: "#D37819",
    d: "M25.185 14.308s1.63.975 1.762 1.842c.155.867-1.762-1.842-1.762-1.842zM30.847 11.294s1.631.976 1.763 1.843c.132.867-1.763-1.843-1.763-1.843z"
  }), react_1.default.createElement("path", {
    fill: "#F68B1F",
    d: "M26.595 8.845s1.807.672 2.424 2.124l-2.424-2.124z"
  })));
};